// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3f3J1","col":"Table_col__2HBRo","fulfillmentStatus":"Table_fulfillmentStatus__1ZwCj","emailCol":"Table_emailCol__2265f"};